<template>
  <main class="service-check">
    <section class="work-header fade-in">
      <div class="header-main">
        <div class="header-title">
          <h1>{{ mozuName }}-{{ applicationType }}-接维查验</h1>
          <div class="meta-row">
            <span><i class="ri-user-line"></i>负责人 {{ todoUser }}</span>
          </div>
        </div>
        <div class="stats">
          <div class="stat">
            <strong>{{ funcroomList.length }}</strong
            ><span>房间数</span>
          </div>
          <div class="stat">
            <strong>{{ deviceList.length }}</strong
            ><span>待查设备</span>
          </div>
          <div class="stat">
            <strong class="warning">{{ totalIssues }}</strong
            ><span>问题数量</span>
          </div>
        </div>
      </div>
    </section>

    <section class="card checklist fade-in">
      <div class="section-head checklist-head">
        <div class="head-label">
          <h2><i class="ri-list-check-2"></i>检查清单</h2>
          <span class="count"
            >共 {{ checkList.length }} 项 · 当前显示 {{ filteredChecks.length }} 项</span
          >
        </div>
        <div class="tools">
          <div class="risk-filter">
            <button
              v-for="item in riskOptions"
              :key="item.key"
              :class="{ active: risk === item.key }"
              @click="risk = item.key"
            >
              {{ item.label }}<em>{{ riskCount(item.key) }}</em>
            </button>
          </div>
          <div class="search">
            <i class="ri-search-line"></i
            ><input v-model="keyword" placeholder="搜索检查项/标准" />
          </div>
        </div>
      </div>
      <div v-if="!filteredChecks.length" class="empty">
        <i class="ri-inbox-line"></i>没有匹配的检查项
      </div>
      <div v-else>
        <div class="mobile-checks">
          <div v-for="group in checkGroups" :key="group.key" class="check-group">
            <div class="group-title">
              <b :class="group.key"></b>{{ group.label
              }}<small>（{{ group.items.length }} 项）</small>
            </div>
            <div v-for="item in group.items" :key="item.id" class="check-card">
              <span :class="['risk-badge', group.key]">{{
                group.label.slice(0, 1)
              }}</span>
              <div>
                <strong v-html="mark(item.item)"></strong>
                <p v-html="mark(item.standard)"></p>
              </div>
            </div>
          </div>
        </div>
        <table class="desktop-checks">
          <thead>
            <tr>
              <th>检查项</th>
              <th>检查标准</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="group in checkGroups"
              ><tr :key="group.key + '-title'" class="group-row">
                <td colspan="2">
                  <b :class="group.key"></b>{{ group.label
                  }}<small>（{{ group.items.length }} 项）</small>
                </td>
              </tr>
              <tr v-for="item in group.items" :key="item.id">
                <td v-html="mark(item.item)"></td>
                <td v-html="mark(item.standard)"></td></tr
            ></template>
          </tbody>
        </table>
      </div>
    </section>

    <section class="rooms-section fade-in">
      <div class="room-title">
        <h2><i class="ri-building-2-line"></i>{{ applicationType }}问题录入</h2>
        <span
          >{{ funcroomList.length }} 个方仓 · 共 {{ deviceList.length }} 台设备<span
            v-if="totalIssues"
          >
            · 已录入 {{ totalIssues }} 个问题</span
          ></span
        >
      </div>
      <div class="room-list">
        <article v-for="room in roomList" :key="room.name" class="card room-card">
          <div class="room-head">
            <div class="room-name">
              <strong>{{ room.name }}</strong>
            </div>
            <div class="room-actions">
              <span v-if="issues[room.name]" class="issue-count">
                <i class="ri-alert-line"></i>{{ issues[room.name].length }} 个问题
              </span>
              <div class="device-total">
                <b>{{ room.devices.length }}</b
                ><small>台设备</small>
              </div>
              <button v-if="canAddIssue" class="add-btn" @click="openModal(room)">
                <i class="ri-add-line"></i><span>新增问题</span>
              </button>
            </div>
          </div>
          <div v-if="issues[room.name]" class="issue-section">
            <button class="issue-list-toggle" @click="toggleRoomIssues(room.name)">
              <i
                :class="
                  isRoomIssuesExpanded(room.name)
                    ? 'ri-arrow-down-s-line'
                    : 'ri-arrow-right-s-line'
                "
              ></i>
              <span>已录入问题{{ issues[room.name].length }}项</span>
            </button>
            <div v-if="isRoomIssuesExpanded(room.name)" class="issue-list">
              <div v-for="issue in issues[room.name]" :key="issue.id" class="issue">
                <div class="issue-meta">
                  <code>{{ issue.id }}</code
                  ><span :class="['severity', riskKey(issue.problem_level)]">{{
                    issue.problem_level
                  }}</span
                  ><span>{{ issue.problem_stage }}</span
                  ><span>{{ issue.problem_type }}</span
                  ><time>{{ issue.createdAt }}</time>
                </div>
                <p>{{ issue.issue_description }}</p>
                <div class="photo-row">
                  <img
                    v-for="photo in issue.photos"
                    :key="photo.name + photo.url"
                    :src="photo.url"
                    :alt="photo.name"
                  />
                </div>
                <div class="affected">
                  影响设备 {{ deviceNumbers(issue.device_number).length }} 台：<code
                    v-for="sn in deviceNumbers(issue.device_number)"
                    :key="sn"
                    >{{ sn }}</code
                  >
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>

    <div v-if="draft" class="modal-wrap" @keydown.esc="closeModal">
      <div class="backdrop" @click="closeModal"></div>
      <div class="modal pop-in">
        <header>
          <div class="modal-icon"><i class="ri-error-warning-line"></i></div>
          <div>
            <h3>录入问题</h3>
            <p>{{ draft.room.name }} · 共 {{ draft.room.devices.length }} 台设备</p>
          </div>
          <button class="close" @click="closeModal"><i class="ri-close-line"></i></button>
        </header>
        <div class="modal-body">
          <div class="device-field">
            <FormLabel text="问题涉及设备" icon="ri-server-line" required blue />
            <div class="device-panel">
              <div class="device-tools">
                <label class="select-all">
                  <input
                    type="checkbox"
                    :checked="allVisibleChecked"
                    @change="toggleAll($event.target.checked)"
                  />全选</label
                ><button class="clear-devices" @click="draft.devices = []">清空</button
                ><span
                  >已选 {{ draft.devices.length }}/{{ draft.room.devices.length }}</span
                >
                <div class="modal-search">
                  <i class="ri-search-line"></i
                  ><input
                    class="search-input"
                    v-model="deviceKeyword"
                    placeholder="搜索编号"
                  />
                </div>
              </div>
              <div class="device-grid">
                <label
                  v-for="device in visibleDevices"
                  :key="device.sn"
                  :class="{ selected: draft.devices.includes(device.sn) }"
                  ><input type="checkbox" :value="device.sn" v-model="draft.devices" />
                  <code>{{ device.sn }}</code></label
                >
                <div v-if="!visibleDevices.length" class="empty-small">
                  未找到匹配设备
                </div>
              </div>
            </div>
          </div>
          <div class="form-field">
            <FormLabel
              text="问题发现阶段"
              icon="ri-flow-chart"
              required
              blue
            /><RadioGroup
              :options="ISSUE_STAGES"
              :value="draft.stage"
              @input="draft.stage = $event"
            />
          </div>
          <div class="form-field">
            <FormLabel
              text="问题类型"
              icon="ri-price-tag-3-line"
              required
              blue
            /><RadioGroup
              :options="ISSUE_TYPES"
              :value="draft.type"
              @input="draft.type = $event"
            />
          </div>
          <div class="form-field">
            <FormLabel
              text="问题级别"
              icon="ri-alarm-warning-line"
              required
              blue
            /><RadioGroup
              :options="SEVERITIES"
              :value="draft.severity"
              risk
              @input="draft.severity = $event"
            />
          </div>
          <div class="form-field">
            <FormLabel text="问题描述" icon="ri-file-text-line" required blue /><textarea
              v-model="draft.description"
              rows="4"
              placeholder="请填写现场发现的具体问题、现象、位置与测量数据"
            ></textarea>
          </div>
          <div class="form-field photos-field">
            <FormLabel text="上传照片" icon="ri-image-add-line" required blue />
            <div class="photos">
              <el-upload
                action="/relay/cosfile/index"
                list-type="picture-card"
                accept="image/*"
                multiple
                :headers="headers"
                :file-list="draft.photos"
                :on-success="handlePhotoUploadSuccess"
                :on-error="handlePhotoUploadError"
                :on-remove="removePhoto"
                :on-preview="previewPhoto"
              >
                <i class="ri-camera-line"></i>
              </el-upload>
            </div>
          </div>
        </div>
        <footer>
          <span
            >已选 {{ draft.devices.length }} 台设备<span v-if="draft.photos.length">
              · {{ draft.photos.length }} 张照片</span
            ></span
          ><button class="cancel" @click="closeModal">取消</button
          ><button class="submit" :disabled="submitting" @click="submit">
            <i :class="submitting ? 'ri-loader-4-line loading' : 'ri-send-plane-line'"></i
            >{{ submitting ? "提交中..." : "提交问题" }}
          </button>
        </footer>
      </div>
    </div>
    <div class="toast-root">
      <div v-for="toast in toasts" :key="toast.id" :class="['toast', toast.type]">
        {{ toast.message }}
      </div>
    </div>
  </main>
</template>

<script>
import { RISK_LEVELS, workOrder, ISSUE_STAGES, ISSUE_TYPES, SEVERITIES } from "./data.js";
import { getDataByNbrokerUrl, getTicketData } from "@/api/workBench/ticketApi.js";

const FormLabel = {
  props: ["text", "icon", "required", "blue"],
  template:
    '<label :class="[\'form-label\', { \'blue-title\': blue }]"><i :class="icon"></i>{{ text }}<b class="required-mark">*</b></label>',
};
const RadioGroup = {
  props: ["options", "value", "risk"],
  methods: {
    label(item) {
      return typeof item === "string" ? item : item.label;
    },
    keyOf(item) {
      return typeof item === "string" ? item : item.key;
    },
  },
  template:
    '<div class="radio-group"><button v-for="item in options" :key="keyOf(item)" :class="{ selected: value === keyOf(item) }" @click="$emit(\'input\', keyOf(item))"><i v-if="risk" :class="[\'dot\', keyOf(item)]"></i>{{ label(item) }}<i v-if="value === keyOf(item)" class="ri-check-line"></i></button></div>',
};
export default {
  name: "connectWith",
  components: { FormLabel, RadioGroup },
  props: {
    mozuName: {
      type: String,
      default: false,
    },
    applicationType: {
      type: String,
      default: false,
    },
    todoUser: {
      type: String,
      default: "-",
    },
    mainTicket: {
      type: String,
      default: "",
    },
    context: {
      type: Object,
      default: () => {},
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    funcroomList: {
      type: Array,
      default: () => [],
    },
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      workOrder,
      RISK_LEVELS,
      ISSUE_STAGES,
      ISSUE_TYPES,
      SEVERITIES,
      risk: "all",
      keyword: "",
      issues: {},
      expandedRooms: {},
      draft: null,
      deviceKeyword: "",
      toasts: [],
      submitting: false,
      canAddIssue: false,

      paramsData: {
        context: {},
        args: {
          problem_data: {},
          funcroom: "",
          process_user: this.$store.state.user.name,
        },
      },
      searchParams: {
        context: {
          service_name: "Db",
          method_name: "query",
          instanceId: "",
          taskId: "",
          parent_id: "",
          parent_task_id: "",
          svckey: "flowable",
        },
        args: {
          db: "jiewei",
          table_name: "on_site_check_problem_ticket",
          start: 0,
          size: 1000,
          fields: [
            "ticket_id",
            "device_number",
            "issue_description",
            "problem_type",
            "problem_photo",
            "idcarea_name",
            "problem_level",
            "problem_stage",
            "main_ticket_id",
          ],
          conditions: {},
        },
      },
      user: sessionStorage.getItem("userid"),
      headers: {
        authToken: sessionStorage.getItem("AuthToken"),
      },
      searchServiceUrl: "http://ibroker-api:8080/nBroker/api/v1/task",
      ServiceUrl: "http://ibroker-jiewei:8080/nBroker/api/v1/task",
    };
  },
  mounted() {
    // this.loadIssues();
  },
  watch: {
    mozuName(newVal) {
      console.log(newVal, "mozu name =====");
    },
    todoUser(newVal) {
      console.log(newVal, "todo user =====");
    },
    mainTicket(newVal) {
      console.log(newVal, "main ticket =====");
      this.loadIssues();
    },
    applicationType(newVal) {
      console.log(newVal, "applicationType =====");
    },
    context: {
      async handler(obj) {
        console.log(obj, "context =====");
        console.log(obj.ticketId, "ticketId ======");
        this.canAddIssue = false;
        if (!obj?.ticketId) return;
        try {
          const result = await getTicketData(obj.ticketId);
          console.log(result, "ticketData ======");
          const list = result?.data?.List || [];
          const ticket = list[0];
          const currentUser = this.user || sessionStorage.getItem("userid");

          const processUsers = ticket?.CurrentAllProcessUsers;
          const includesCurrentUser = Array.isArray(processUsers)
            ? processUsers.includes(currentUser)
            : String(processUsers || "").includes(currentUser);

          this.canAddIssue =
            list.length > 0 &&
            includesCurrentUser &&
            ticket.TicketStatus === "OPEN";
        } catch (error) {
          console.error(error, "get ticket data failed ======");
        }
      },
      immediate: true,
    },
    checkList: {
      handler(list) {
        console.log(list, "checkList =====");
      },
      immediate: true,
    },
    funcroomList: {
      handler(list) {
        console.log(list, "funcroomList =====");
      },
      immediate: true,
    },
    deviceList: {
      handler(list) {
        console.log(list, "deviceList ====");
      },
      immediate: true,
    },
  },
  computed: {
    totalDevices() {
      return this.deviceList.length;
    },
    totalIssues() {
      return Object.values(this.issues).reduce((sum, list) => sum + list.length, 0);
    },
    roomList() {
      return this.funcroomList.map((room) => {
        const name =
          typeof room === "string" ? room : room.FuncRoomName || room.name || room.value;
        const deviceNumbers = this.deviceList
          .filter((device) => String(device.FuncRoomName) === String(name))
          .reduce((numbers, device) => {
            const rawNumbers = device.DeviceNumber;
            const currentNumbers = Array.isArray(rawNumbers)
              ? rawNumbers
              : rawNumbers == null
              ? []
              : typeof rawNumbers === "object"
              ? Object.values(rawNumbers)
              : [rawNumbers];
            return numbers.concat(currentNumbers);
          }, []);
        return {
          name,
          devices: deviceNumbers.map((sn) => ({
            sn: String(
              sn && typeof sn === "object"
                ? sn.DeviceNumber ||
                    sn.deviceNumber ||
                    sn.DeviceNo ||
                    sn.sn ||
                    sn.value ||
                    ""
                : sn
            ),
            model: "",
          })),
        };
      });
    },
    riskOptions() {
      return [
        { key: "all", label: "全部" },
        { key: "high", label: "高风险" },
        { key: "mid", label: "中风险" },
        { key: "low", label: "低风险" },
      ];
    },
    filteredChecks() {
      const key = this.keyword.trim().toLowerCase();
      return this.checkList
        .map((item) => ({
          ...item,
          item: item.check_content,
          standard: item.check_standard,
          category: item.check_item_type,
          risk: this.riskKey(item.level),
        }))
        .filter(
          (item) =>
            (this.risk === "all" || item.risk === this.risk) &&
            (!key ||
              `${item.item}${item.standard}${item.category}${item.id}`
                .toLowerCase()
                .includes(key))
        );
    },
    checkGroups() {
      return ["high", "mid", "low"]
        .map((key) => ({
          key,
          label: `${this.RISK_LEVELS[key].label}风险`,
          items: this.filteredChecks.filter((item) => item.risk === key),
        }))
        .filter((group) => group.items.length);
    },
    visibleDevices() {
      if (!this.draft) return [];
      const key = String(this.deviceKeyword || "")
        .trim()
        .toLowerCase();
      return this.draft.room.devices.filter((device) => {
        const deviceNumber = String(device.sn || "").toLowerCase();
        const model = String(device.model || "").toLowerCase();
        return !key || `${deviceNumber}${model}`.includes(key);
      });
    },
    allVisibleChecked() {
      return (
        this.visibleDevices.length > 0 &&
        this.visibleDevices.every((device) => this.draft.devices.includes(device.sn))
      );
    },
  },
  methods: {
    riskCount(key) {
      return key === "all"
        ? this.checkList.length
        : this.checkList.filter((item) => this.riskKey(item.level) === key).length;
    },
    riskKey(level) {
      return (
        {
          高风险: "high",
          中风险: "mid",
          低风险: "low",
          高: "high",
          中: "mid",
          低: "low",
        }[level] || "low"
      );
    },
    isRoomIssuesExpanded(roomName) {
      return Boolean(this.expandedRooms[roomName]);
    },
    toggleRoomIssues(roomName) {
      this.$set(this.expandedRooms, roomName, !this.isRoomIssuesExpanded(roomName));
    },
    deviceNumbers(value) {
      if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter(Boolean);
      }
      return String(value || "")
        .split(";")
        .map((item) => item.trim())
        .filter(Boolean);
    },
    mark(text) {
      const key = this.keyword.trim();
      if (!key) return this.escape(text);
      return this.escape(text).replace(
        new RegExp(`(${this.escapeReg(key)})`, "gi"),
        "<mark>$1</mark>"
      );
    },
    escape(text) {
      return String(text).replace(
        /[&<>"']/g,
        (value) =>
          ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[value])
      );
    },
    escapeReg(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    severityLabel(key) {
      return this.RISK_LEVELS[key].label;
    },
    photoUrl(photo) {
      return photo?.response?.FileList?.[0]?.url || photo?.url || "";
    },
    normalizePhotos(value) {
      if (!value || value === "None") return [];
      let photos = value;
      if (typeof photos === "string") {
        try {
          photos = JSON.parse(photos.replace(/'/g, '"'));
        } catch (error) {
          photos = photos.split(",").map((url) => ({ url: url.trim() }));
        }
      }
      if (!Array.isArray(photos)) photos = [photos];
      return photos
        .map((photo, index) => {
          const file = photo?.response?.FileList?.[0] || photo;
          const url = file?.url || file?.URL || (typeof file === "string" ? file : "");
          return url ? { name: file?.name || `问题照片${index + 1}`, url } : null;
        })
        .filter(Boolean);
    },
    async loadIssues() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      params.args.conditions = {
        check_ticket_id: this.mainTicket,
        idcarea_name: this.funcroomList,
      };
      try {
        const result = await getDataByNbrokerUrl(params, this.searchServiceUrl);
        const resultData = result?.data?.result || {};
        const rows = Array.isArray(resultData) ? resultData : resultData.data || [];
        const grouped = {};
        rows.forEach((row, index) => {
          const roomName = row.idcarea_name;
          if (!roomName) return;
          const issue = {
            ...row,
            id: row.ticket_id || row.id || `ISSUE-${index + 1}`,
            photos: this.normalizePhotos(row.problem_photo),
            createdAt: row.createdAt || row.create_time || row.created_time || "",
          };
          if (!grouped[roomName]) grouped[roomName] = [];
          grouped[roomName].push(issue);
        });
        this.issues = grouped;
      } catch (error) {
        this.toast("历史问题查询失败", "error");
      }
    },
    handlePhotoUploadSuccess(response, file, fileList) {
      file.response = response;
      this.draft.photos = fileList;
    },
    handlePhotoUploadError() {
      this.toast("照片上传失败", "error");
    },
    removePhoto(file, fileList) {
      this.draft.photos = fileList;
    },
    previewPhoto(file) {
      const url = this.photoUrl(file);
      if (url) window.open(url, "_blank");
    },
    openModal(room) {
      this.deviceKeyword = "";
      this.draft = {
        room,
        devices: [],
        stage: "",
        type: "",
        severity: "",
        description: "",
        photos: [],
      };
    },
    closeModal() {
      this.draft = null;
    },
    toggleAll(checked) {
      const visible = this.visibleDevices.map((device) => device.sn);
      this.draft.devices = checked
        ? [...new Set([...this.draft.devices, ...visible])]
        : this.draft.devices.filter((sn) => !visible.includes(sn));
    },
    toast(message, type = "success") {
      const id = Date.now();
      this.toasts.push({ id, message, type });
      setTimeout(() => {
        this.toasts = this.toasts.filter((item) => item.id !== id);
      }, 2400);
    },
    submit() {
      if (this.submitting) return;
      console.log(sessionStorage.getItem("userid"), "user ====");
      const d = this.draft;
      if (!d.devices.length) return this.toast("请至少勾选一台设备", "error");
      if (!d.stage) return this.toast("请选择问题发现阶段", "error");
      if (!d.type) return this.toast("请选择问题类型", "error");
      if (!d.severity) return this.toast("请选择问题级别", "error");
      if (!d.description.trim()) return this.toast("请填写问题描述", "error");
      if (!d.photos.length) return this.toast("请至少上传一张照片", "error");
      const issue = {
        id: `IS-${String(Date.now()).slice(-6)}`,
        device_number: d.devices.join(";"),
        problem_stage: d.stage,
        problem_type: d.type,
        problem_level: this.RISK_LEVELS[d.severity].label,
        issue_description: d.description.trim(),
        photos: d.photos
          .map((photo, index) => ({
            name: photo.name || `问题照片${index + 1}`,
            url: this.photoUrl(photo),
          }))
          .filter((photo) => photo.url),
        createdAt: "",
      };
      this.paramsData.args.problem_data = {
        device_number: issue.device_number,
        problem_stage: issue.problem_stage,
        problem_type: issue.problem_type,
        problem_level: issue.problem_level,
        issue_description: issue.issue_description,
        photos: issue.photos,
      };
      this.paramsData.args.funcroom = d.room.name;
      this.paramsData.args.process_user = this.user;
      this.paramsData.context = {
        ...this.context,
        service_name: "CheckTicketOnSiteDevice11",
        method_name: "create_problem_ticket",
      };
      console.log("提交的问题对象:", issue);
      console.log(this.paramsData, "params =====");
      this.submitting = true;
      getDataByNbrokerUrl(this.paramsData, this.ServiceUrl)
        .then(() => {
          this.$set(this.issues, d.room.name, [
            issue,
            ...(this.issues[d.room.name] || []),
          ]);
          this.draft = null;
          this.toast(`问题 ${issue.id} 提交成功，涉及 ${d.devices.length} 台设备`);
        })
        .catch(() => this.toast("问题提交失败", "error"))
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css");
* {
  box-sizing: border-box;
}
.service-check {
  width: 100%;
  min-height: 100vh;
  padding: clamp(12px, 3vw, 24px) clamp(12px, 4vw, 4%);
  background: #f1f5f9;
  color: #1e293b;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei",
    sans-serif;
}
.work-header {
  max-width: 1600px;
  margin: 0 auto 24px;
  padding: 24px;
  color: white;
  border-radius: 12px;
  background: linear-gradient(110deg, #2b57d6, #4f46e5);
  box-shadow: 0 1px 3px #0001;
}
.header-main {
  display: flex;
  align-items: flex-start;
  gap: clamp(16px, 3vw, 24px);
}
.header-title {
  flex: 1;
  min-width: 0;
}
h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.4;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  margin-top: 10px;
  color: #ffffffcc;
  font-size: 14px;
}
.meta-row span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  flex-shrink: 0;
  text-align: center;
}
.stat {
  min-width: 75px;
  padding: 8px 16px;
  border-radius: 8px;
  background: #ffffff26;
  outline: 1px solid #ffffff33;
}
.stat strong {
  display: block;
  font-size: 24px;
  line-height: 1.2;
}
.stat span {
  display: block;
  margin-top: 4px;
  color: #ffffffbf;
  font-size: 12px;
  white-space: nowrap;
}
.stat .warning {
  color: #fde68a;
}
.card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px #0000000a;
}
.checklist {
  max-width: 1600px;
  margin: 0 auto 24px;
  overflow: hidden;
}
.section-head {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.checklist-head {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}
.head-label,
.room-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.head-label h2,
.room-title h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}
.head-label h2 i,
.room-title h2 i {
  color: #2b57d6;
}
.count {
  padding: 3px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
}
.tools {
  display: flex;
  align-items: center;
  gap: 12px;
}
.risk-filter {
  display: flex;
  gap: 4px;
}
.risk-filter button {
  padding: 6px 10px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
}
.risk-filter button.active {
  color: white;
  background: #2b57d6;
  border-color: #2b57d6;
}
.risk-filter em {
  margin-left: 4px;
  opacity: 0.7;
  font-style: normal;
}
.search,
.modal-search {
  position: relative;
}
.search i,
.modal-search i {
  position: absolute;
  left: 10px;
  top: 50%;
  color: #94a3b8;
  transform: translateY(-50%);
}
.search input,
.modal-search input {
  width: 208px;
  padding: 7px 12px 7px 30px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  outline: none;
  font-size: 13px;
}
.search input:focus,
.modal-search input:focus,
textarea:focus {
  border-color: #3b6ef5;
  box-shadow: 0 0 0 3px #dbe6fe;
}
.desktop-checks {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;
}
.desktop-checks th {
  padding: 10px 20px;
  color: #64748b;
  background: #f1f5f9;
  font-size: 12px;
  font-weight: 500;
}
.desktop-checks th:first-child {
  width: 33%;
}
.desktop-checks td {
  padding: 12px 20px;
  border-top: 1px solid #f1f5f9;
  vertical-align: top;
  font-size: 14px;
  line-height: 1.7;
}
.desktop-checks td:first-child {
  font-weight: 500;
}
.group-row td {
  padding: 8px 20px;
  color: #64748b;
  background: #f8fafc;
  font-size: 12px;
}
.group-row b,
.group-title b {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 7px;
  border-radius: 50%;
}
.high {
  background: #ef4444;
}
.mid {
  background: #f59e0b;
}
.low {
  background: #10b981;
}
.group-row small,
.group-title small {
  margin-left: 4px;
  color: #94a3b8;
  font-weight: normal;
}
.mobile-checks {
  display: none;
}
mark {
  padding: 1px 2px;
  border-radius: 3px;
  background: #fef08a;
}
.empty {
  padding: 64px;
  color: #94a3b8;
  text-align: center;
  font-size: 14px;
}
.empty i {
  display: block;
  margin-bottom: 8px;
  font-size: 30px;
}
.rooms-section {
  max-width: 1600px;
  margin: 0 auto;
}
.room-title {
  margin-bottom: 16px;
}
.room-title span {
  color: #64748b;
  font-size: 12px;
}
.room-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.room-head {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding: 16px;
}
.room-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}
.modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #2b57d6;
  background: #eef4ff;
  border-radius: 8px;
  flex-shrink: 0;
}
.room-name {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.room-name strong {
  overflow-wrap: anywhere;
}
.room-head .device-total {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  margin: 0;
  text-align: left;
}
.room-head .issue-count {
  margin: 0;
}
.room-actions .add-btn {
  margin-left: auto;
}
.room-name strong {
  font-size: 14px;
}
.room-name code,
.issue-meta code,
.affected code {
  color: #64748b;
  font-family: monospace;
  font-size: 11px;
}
.room-name code {
  padding: 3px 6px;
  background: #f1f5f9;
  border-radius: 4px;
}
.issue-count {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
  min-height: 24px;
  padding: 3px 9px;
  color: #b42318;
  background: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}
.issue-count i {
  font-size: 13px;
}
.device-total {
  margin-right: 8px;
  text-align: right;
}
.device-total b {
  display: inline-block;
  color: #2b57d6;
  font-size: 24px;
  line-height: 1;
}
.device-total small {
  color: #94a3b8;
  font-size: 11px;
}
.add-btn,
.submit,
.cancel {
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
}
.add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #2b57d6;
  background: #eef4ff;
  white-space: nowrap;
}
.add-btn i {
  font-size: 15px;
  line-height: 1;
}
.add-btn span {
  line-height: 1;
}
.issue-section {
  border-top: 1px solid #f1f5f9;
}
.issue-list-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 10px 16px 6px;
  color: #64748b;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
}
.issue-list-toggle i {
  font-size: 16px;
}
.issue-list {
  padding: 0 16px 16px;
}
.issue {
  margin-top: 10px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.issue-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
}
.issue-toggle {
  cursor: pointer;
  user-select: none;
}
.issue-toggle > i {
  color: #64748b;
  font-size: 16px;
}
.issue-meta span {
  padding: 3px 7px;
  color: #475569;
  background: #fff;
  border-radius: 99px;
  box-shadow: 0 0 0 1px #e2e8f0;
}
.issue-meta .severity {
  box-shadow: none;
}
.severity.high {
  color: #dc2626;
  background: #fef2f2;
}
.severity.mid {
  color: #d97706;
  background: #fffbeb;
}
.severity.low {
  color: #059669;
  background: #ecfdf5;
}
.issue-meta time {
  margin-left: auto;
  color: #94a3b8;
}
.issue p {
  margin: 7px 0;
  font-size: 14px;
  line-height: 1.7;
}
.photo-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.photo-row img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}
.affected {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 11px;
}
.affected code {
  padding: 3px 6px;
  color: #475569;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px #e2e8f0;
}
.modal-wrap {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
}
.backdrop {
  position: absolute;
  inset: 0;
  background: #0f172a80;
  backdrop-filter: blur(2px);
}
.modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(94%, 768px);
  max-height: min(90vh, 900px);
  overflow: hidden;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 50px #0003;
}
.modal header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.modal header h3 {
  margin: 0;
  font-size: 16px;
}
.modal header p {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}
.close {
  margin-left: auto;
  width: 32px;
  height: 32px;
  color: #94a3b8;
  background: none;
  border: 0;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
}
.close:hover {
  background: #f1f5f9;
}
.modal-body {
  padding: 16px 20px;
  overflow-y: auto;
}
.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
.form-label i {
  color: #333;
  font-size: 16px;
}
.form-label.blue-title i {
  color: #2f6fed;
}
.form-label .required-mark {
  display: inline-block !important;
  margin-left: 3px !important;
  color: #f5222d !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.device-field {
  padding-bottom: 16px;
}
.form-field {
  padding: 16px 0;
  border-top: 1px solid #f1f5f9;
}
.device-panel {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.device-tools {
  display: grid;
  grid-template-columns: auto auto 1fr minmax(180px, 240px);
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  color: #475569;
  font-size: 12px;
}
.device-tools button {
  height: 28px;
  padding: 0 10px;
  color: #333;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.device-tools .select-all {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  color: #334155;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
}
.device-tools .select-all:hover,
.device-tools .select-all:has(input:checked) {
  color: #2563eb;
  border-color: #91caff;
  background: #eaf4ff;
}
.device-tools .select-all input {
  width: 15px;
  height: 15px;
  accent-color: #2f6fed;
}
.device-tools .clear-devices {
  height: 28px;
  padding: 0 11px;
  color: #64748b;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
}
.device-tools .clear-devices:hover {
  color: #ef4444;
  border-color: #fca5a5;
  background: #fff5f5;
}
.device-tools span {
  padding-left: 2px;
  color: #64748b;
  font-size: 12px;
}
.modal-search {
  position: relative;
  width: 100%;
}
.modal-search input {
  width: 100% !important;
  min-width: 0;
  padding: 5px 10px 5px 30px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  font-size: 12px;
  transition: 0.2s;
}
.modal-search input:focus {
  border-color: #6ea8fe;
  box-shadow: 0 0 0 3px rgba(47, 111, 237, 0.12);
}
.device-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  max-height: 176px;
  padding: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.device-grid::-webkit-scrollbar {
  width: 6px;
}
.device-grid::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}
.device-grid label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  padding: 6px 8px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  cursor: pointer;
}
.device-grid label.selected {
  border-color: #91caff;
  background: #eaf4ff;
  box-shadow: inset 0 0 0 1px rgba(24, 144, 255, 0.08);
}
.device-tools search-input,
.device-grid input {
  width: 14px;
  height: 14px;
  accent-color: #409eff;
}
.device-grid code {
  min-width: 0;
  color: #475569;
  font-size: 11px;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: break-all;
}
.empty-small {
  grid-column: 1/-1;
  padding: 24px;
  color: #94a3b8;
  text-align: center;
  font-size: 12px;
}
.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.radio-group button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 86px;
  height: 36px;
  padding: 0 14px;
  color: #334155;
  background: #fff;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: color 0.2s, background 0.2s, border-color 0.2s, box-shadow 0.2s,
    transform 0.2s;
}
.radio-group button.selected {
  color: #fff;
  background: linear-gradient(135deg, #3478f6, #2563eb);
  border-color: #2563eb;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.22);
}
.radio-group button:hover:not(.selected) {
  color: #2563eb;
  border-color: #8ab4ff;
  background: #f5f9ff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
  transform: translateY(-1px);
}
.radio-group .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 8px;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
}
.radio-group .dot.high {
  background: #ef4444;
}
.radio-group .dot.mid {
  background: #f59e0b;
}
.radio-group .dot.low {
  background: #10b981;
}
.radio-group .ri-check-line {
  color: inherit;
}
.modal textarea {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  outline: none;
  resize: none;
  color: #1a1a1a;
  font: 13px/1.6 inherit;
}
.photos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.photo,
.upload {
  position: relative;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border-radius: 8px;
}
.photo {
  border: 1px solid #e2e8f0;
}
.photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo span {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 3px;
  overflow: hidden;
  color: white;
  background: #0f172a99;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.photo button {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  color: #fff;
  background: #0f172a99;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #94a3b8;
  background: #fff;
  border: 2px dashed #cbd5e1;
  cursor: pointer;
  font-size: 11px;
}
.upload i {
  font-size: 20px;
}
.modal footer {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
  padding: 8px 16px;
  color: #999;
  background: #fafafa;
  border-top: 1px solid #e6e6e6;
  font-size: 12px;
}
.cancel {
  height: 32px;
  margin-left: auto;
  padding: 0 15px;
  color: #333;
  background: #fff;
  border: 1px solid #d9d9d9;
  box-shadow: none;
  border-radius: 4px;
}
.cancel:hover {
  color: #409eff;
  border-color: #409eff;
}
.submit {
  height: 32px;
  padding: 0 15px;
  color: #fff;
  background: #409eff;
  border: 1px solid #409eff;
  box-shadow: none;
  border-radius: 4px;
}
.submit:hover {
  background: #40a9ff;
  border-color: #40a9ff;
}
.submit:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
.loading {
  display: inline-block;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.modal /deep/ .form-label i {
  color: #333;
  font-size: 16px;
}
.modal /deep/ .form-label i,
.modal /deep/ .modal-icon i,
.modal /deep/ .close i,
.modal /deep/ .upload i,
.modal /deep/ .submit i,
.modal /deep/ .modal-search i {
  color: #2f6fed;
}
.modal /deep/ .form-label.blue-title i {
  color: #2f6fed;
}
.modal /deep/ .form-label .required-mark {
  display: inline-block !important;
  margin-left: 3px !important;
  color: #f5222d !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.modal /deep/ .radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.modal /deep/ .radio-group button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 86px;
  height: 36px;
  padding: 0 14px;
  color: #334155;
  background: #fff;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: color 0.2s, background 0.2s, border-color 0.2s, box-shadow 0.2s,
    transform 0.2s;
}
.modal /deep/ .radio-group button.selected {
  color: #fff;
  background: linear-gradient(135deg, #3478f6, #2563eb);
  border-color: #2563eb;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.22);
}
.modal /deep/ .radio-group button:hover:not(.selected) {
  color: #2563eb;
  border-color: #8ab4ff;
  background: #f5f9ff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
  transform: translateY(-1px);
}
.modal /deep/ .radio-group .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
}
.modal /deep/ .radio-group .dot.high {
  background: #ef4444;
}
.modal /deep/ .radio-group .dot.mid {
  background: #f59e0b;
}
.modal /deep/ .radio-group .dot.low {
  background: #10b981;
}
.toast-root {
  position: fixed;
  top: 80px;
  left: 50%;
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transform: translateX(-50%);
}
.toast {
  padding: 10px 16px;
  color: white;
  border-radius: 8px;
  box-shadow: 0 8px 18px #0002;
  white-space: nowrap;
  font-size: 13px;
}
.toast.success {
  background: #059669;
}
.toast.error {
  background: #dc2626;
}
.fade-in {
  animation: fadeIn 0.25s ease both;
}
.pop-in {
  animation: popIn 0.2s ease both;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 64em) {
  .checklist-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .tools {
    width: 100%;
    justify-content: space-between;
  }
  .search input {
    width: min(208px, 42vw);
  }
}
@media (max-width: 47.9375em) {
  .service-check {
    padding: 16px 4%;
  }
  .modal {
    width: 94%;
    max-height: 92vh;
    border-radius: 14px;
  }
  .work-header {
    padding: 16px;
    margin-bottom: 16px;
  }
  .header-main {
    display: block;
  }
  .header-title h1 {
    word-break: break-word;
  }
  h1 {
    font-size: 18px;
  }
  .meta-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
  }
  .stats {
    margin-top: 16px;
    gap: 8px;
  }
  .stat {
    padding: 7px 8px;
    min-width: 0;
  }
  .stat strong {
    font-size: 20px;
  }
  .checklist {
    margin-bottom: 16px;
  }
  .section-head {
    padding: 14px 16px;
  }
  .checklist-head {
    display: block;
  }
  .head-label {
    min-width: 0;
  }
  .tools {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    margin-top: 12px;
  }
  .risk-filter {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
  }
  .risk-filter button {
    padding: 7px 2px;
    font-size: 11px;
  }
  .search,
  .search input {
    width: 100%;
  }
  .mobile-checks {
    display: block;
  }
  .desktop-checks {
    display: none;
  }
  .group-title {
    padding: 8px 16px;
    color: #475569;
    background: #f8fafc;
    font-size: 12px;
  }
  .check-card {
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #f1f5f9;
  }
  .check-card strong {
    display: block;
    font-size: 13px;
    line-height: 1.5;
  }
  .check-card p {
    margin: 4px 0 0;
    color: #475569;
    font-size: 12px;
    line-height: 1.6;
  }
  .risk-badge {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 0;
    color: #fff;
    border-radius: 4px;
    font-size: 11px;
    line-height: 1;
  }
  .room-title {
    display: block;
    margin-bottom: 12px;
  }
  .room-title h2 {
    margin-bottom: 6px;
  }
  .room-head {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
    gap: 10px;
  }
  .room-actions {
    display: flex;
    gap: 8px;
  }
  .room-head .issue-count {
    margin-left: 0;
  }
  .room-name {
    overflow-wrap: anywhere;
  }
  .room-head .device-total {
    width: auto;
    margin: 0 4px;
  }
  .room-name strong {
    font-size: 13px;
  }
  .device-total {
    margin-right: 0;
  }
  .device-total b {
    font-size: 20px;
  }
  .add-btn {
    min-width: 84px;
    padding: 7px 8px;
    font-size: 12px;
  }
  .add-btn i {
    margin-right: 0;
    font-size: 15px;
  }
  .issue-list {
    padding: 4px 12px 12px;
  }
  .issue-meta time {
    width: 100%;
    margin-left: 0;
  }
  .modal-body {
    padding: 14px 16px;
  }
  .modal header {
    padding: 14px 16px;
  }
  .device-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .device-tools {
    grid-template-columns: repeat(2, minmax(0, auto));
  }
  .device-tools .select-all,
  .device-tools .clear-devices {
    min-width: 0;
  }
  .device-tools span,
  .modal-search {
    grid-column: 1 / -1;
  }
  .modal-search input {
    width: 100% !important;
    min-width: 0;
  }
  .modal footer {
    padding: 12px 16px;
  }
  .modal footer > span {
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
